import { useState,useEffect } from "react";
import GridCheckbox from "../ui/checkbox/GridCheckbox";

// Function for rendering the checkbox column
const RenderGridCheckboxColumn = ({
  rowData,
  col,
  rowIndex,
  onColumnDataChange
}) => {
  const [value, setValue] = useState(rowData[col.fieldName]);
  const { colSettings, fieldName } = col;
  const isDisabled = typeof col.colSettings?.isDisabled === 'function'
  ? col.colSettings.isDisabled(rowData)
  : col.colSettings?.isDisabled;


    useEffect(() => {
    setValue(rowData[fieldName]);
  }, [rowData, fieldName]);

  const handleCheckboxChange = (e) => {
    const newValue = !value;
    setValue(newValue);

    if (onColumnDataChange) {
      const newRowData = { ...rowData, [fieldName]: newValue };
      onColumnDataChange(fieldName, newRowData, rowIndex);
    }
  };

  return (
    <GridCheckbox
      type="checkbox"
      checked={value}
      disabled={isDisabled}
      onChange={(handleCheckboxChange)}
    />
  );
};


export default RenderGridCheckboxColumn